export default __webpack_public_path__ + "static/media/settings-dark.ddf91278.svg";